import { type RefObject } from "react";
import { CogentLessons } from "@softmax/cogent-sdk/react";

import type { CogentLive } from "./chat-view";

import { WidgetStatusLine } from "../notices/widget-status";
import type { WidgetActions } from "../use-widget-actions";
import type { CogentWidgetProps } from "../widget-types";
import s from "../cogent.module.css";
import { ChatLog } from "./chat-log";
import { ChatChoices } from "./chat-choices";
import { ChatComposer } from "./chat-composer";
import { ChatSetup } from "./chat-setup";

export function WidgetConversation({
  name,
  cogent,
  start,
  live,
  actions,
  log,
}: {
  name: string;
  cogent: NonNullable<CogentWidgetProps["cogent"]>;
  start: CogentWidgetProps["start"];
  live: CogentLive | null;
  actions: WidgetActions;
  log: RefObject<HTMLDivElement | null>;
}) {
  return (
    <>
      {live ? (
        <CogentLessons
          className={s.lessons}
          lessons={live.lessons}
          forget={live.forgetLesson}
        />
      ) : null}
      {live ? <ChatLog name={name} live={live} log={log} /> : null}
      {live?.question ? (
        <ChatChoices question={live.question} send={live.send} />
      ) : null}
      <WidgetStatusLine actions={actions} />
      {cogent.sendable ? (
        <ChatComposer name={name} live={live} actions={actions} />
      ) : (
        <ChatSetup name={name} start={start} />
      )}
    </>
  );
}
